export default {
  methods: {
    createPopUpDistribution (vm, feature) {
      vm.selectedCommerce.businessAvailable = []
      let businessAvailable = []
      vm.panel.sidebarRight = true
      vm.sidebarRightSection.commerce = true
      vm.selectedCommerce.properties = feature.properties
      vm.geojson.features.forEach((element) => {
        if (
          element.properties.point_de_distribution !== false &&
          element.properties.point_de_distribution !== null
        ) {
          element.properties.point_de_distribution.forEach((elemen2) => {
            if (elemen2.ID === vm.selectedCommerce.properties.id) {
              businessAvailable.push(element)
            }
          })
        }
      })
      vm.selectedCommerce.businessAvailable = this.unifyData(
        businessAvailable,
        'name'
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/methods.js